import z from "zod";

const translationPath = "page.4uDlist.generationRule.schedule.errors.";

export const scheduleSchema = z.object({
  id: z.string().optional(),
  identifier: z.string().min(1, translationPath + "identifier"),
});

export type TScheduleForm = z.infer<typeof scheduleSchema>;
